import { TestTube2 } from "lucide-react";

/**
 * Small "Tester" flair shown next to usernames in posts, comments, DMs, and
 * profile headers. Rendered only when the user has `is_tester === true`.
 */
export default function TesterBadge({ className = "", size = "sm" }) {
  const px = size === "xs" ? "px-1.5 py-0" : "px-2 py-0.5";
  const text = size === "xs" ? "text-[9px]" : "text-[10px]";
  const iconSize = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <span
      title="Tester — free access to all features"
      className={`inline-flex items-center gap-1 rounded-full ${px} ${text} font-semibold uppercase tracking-wide bg-[#2F80ED]/15 text-[#1D5FBF] ${className}`}
      data-testid="tester-badge"
    >
      <TestTube2 className={iconSize} /> Tester
    </span>
  );
}
